import React, { Component } from "react";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import { View_Paradan_Bill } from "../../../actions_agent/Invoice_action";
import PrintViewParadan from "./PrintViewParadan";
import PrintViewParadanEn from "./PrintViewParadanEn";
class PrintRePayments extends Component {
 componentDidMount() {
  this.props.View_Paradan_Bill(
   this.props.match.params.id,
   this.props.match.params.index
  );
 }
 render() {
  const { lang, view_paradan_obj } = this.props;
  return (
   <>
    {lang === "krd" ? (
     <PrintViewParadan view_paradan_obj={view_paradan_obj} />
    ) : lang === "arb" ? (
     <PrintViewParadan view_paradan_obj={view_paradan_obj} />
    ) : (
     <PrintViewParadanEn view_paradan_obj={view_paradan_obj} />
    )}
   </>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  view_paradan_obj: state.Invoice_Reducer.view_paradan_obj,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
  View_Paradan_Bill: (id, index) => dispatch(View_Paradan_Bill(id, index)),
 };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrintRePayments);
